<script>
import { simulateTime } from "../../../game";

export default {
  name: "AdsTab",
  computed: {
    isAbleToWatch() {
      return player.records.totalAntimatter.gt(10);
    }
  },
  methods: {
    watchRewarded() {
      ysdk.adv.showRewardedVideo({
        callbacks: {
          onRewarded: () => simulateTime(600),
          onError: () => GameUI.notify.error("Просмотр не засчитан, возникла ошибка")
        }
      });
    },
  }
};
</script>

<template>
  <div class="tab ads">
    <h1 v-if="!isAbleToWatch">
      Для просмотра рекламы необходимо купить хотя бы одно Измерение Антиматерии
    </h1>
    <button
      class="o-primary-btn o-primary-btn--new o-primary-btn--ads"
      :disabled="!isAbleToWatch"
      @click="watchRewarded"
    >
      Смотреть Рекламу за 10 минут офлайн прогресса
    </button>
  </div>
</template>

<style scoped>
.ads {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--color-text);
}

.o-primary-btn--ads {
  display: flex;
  width: 50rem;
  height: 12rem;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
}

.o-primary-btn--ads:disabled {
  background: #752626;
  border-color: var(--color-bad);
  cursor: auto;
}
</style>